/** @jsx jsx */

import React, { useEffect, useState, useRef } from "react";
import { jsx, css } from "@emotion/react";
import ScreenShotTaker from "./ImgScreenShot/ScreenShotTaker";
import UploaderForm from "./Form/UploaderForm";
import UploaderVideoPreview from "./Preview/UploaderVideoPreview";
import LiveSelection from "./LiveSelection/LiveSelection";
import Progress from "./ProgressBlock/Progress";
import UploaderModal from "./Modal/UploaderModal";
import { isFileTooBigError, isFileTooSmallError, isFileTypeError } from "./helpers/utils";

const onePadding = css`
  padding-top:1em;
  padding-bottom:1em;
`;

const onePaddingTiltle = css`
  padding-bottom:1em;
`;

const imgPreviewDiv = css`
    display: flex;
`;

interface LargeFileUploaderProps {
    demop: string,
    isScreenShot: boolean,
    isPreview: boolean,
    videoType: string,
    fileType: string,
    uploadEvent: Blob | undefined,
    previewSrc: Blob | undefined,
    isSafari: boolean,
    videoSrc: string,
    isUploadButtonDisabled: boolean,
    originalFileName: string
}

const LargeFileUploader: React.FC<LargeFileUploaderProps> = (props) => {

    const [isScreenShot, setIsScreenShot] = useState<boolean>();
    const [isPreview, setIsPreview] = useState<boolean>(false);
    const [isLiveSelected, setIsLiveSelected] = useState<boolean>(false);
    const [uploadEvent, setUploadEvent] = useState<Blob>();
    const [previewVideoSrc, setPreviewVideoSrc] = useState<Blob>();
    const [videoType, setVideoType] = useState<string>("");
    const [isSafari, setIsSafari] = useState<boolean>();
    const [uploadedvideoSrc, setUploadedvideoSrc] = useState<string>();
    const [fileSize, setFileSize] = useState<number>(0);
    const [isFileSelected, setIsFileSelected] = useState<boolean>(false);
    const [originalFileName, setOriginalFileName] = useState<string>("");
    const [isProgress, setIsProgress] = useState<boolean>();
    const [uploadPath, setUploadPath] = useState<string>("");
    const [isModal, setIsModal] = useState<boolean>(false);
    const [uploaderFormKey, setUploaderFormKey] = useState<number>(0);

    const [modalTitle, setModalTitle] = useState<string>("");
    const [modalMessage, setmodalMessage] = useState<string>("");
    const [isFileUiDisabled, setIsFileUiDisabled] = useState<boolean>(false);
    const [linkDisplay, setLinkDisplay] = useState<string>("none");

    const uploaderFormCallback = (childData: any) => {
        const fakeBlob: any = childData.target.files[0]; // NB: TypeScript BUG:  https://github.com/microsoft/TypeScript/issues/34652
        setUploadEvent(childData.target.files[0]);
        const fileInfo = childData.target.files[0];
        if (isFileTypeError(fakeBlob.type)) {
            displayFileError("エラー", "サポートされているビデオファイルタイプではありません。");
        } else if (isFileTooBigError(fakeBlob.size)) {
            displayFileError("エラー", "ファイルサイズが大きすぎます。");
        } else if (isFileTooSmallError(fakeBlob.size)) {
            displayFileError("エラー", "ファイルサイズが小さすぎます。");
        } else {
            setFileInfo(fileInfo, fakeBlob.name);
        }
    }

    const displayFileError = (title, message) => {
        setModalTitle(title);
        setmodalMessage(message);
        setIsModal(true);
        setUploaderFormKey(Date.now()); // reset the file input element
    }

    const liveSelectionCallback = (childValue) => {
        setIsLiveSelected(childValue != "");
        setUploadPath(`contents/ch${childValue}/SourceFile${childValue}.mp4`);
        setLinkDisplay("");
    }

    const uploaderModalCallback = (e) => {
        setIsModal(false);
    }

    const setFileInfo = (fileInfo: Blob, name: string) => {
        setVideoType(fileInfo.type);
        setPreviewVideoSrc(fileInfo);
        setFileSize(fileInfo.size);
        try {
            setOriginalFileName(name);
        } catch (e) {
            console.log(e);
        }

        setIsScreenShot(true);
        setIsFileSelected(true);
    }

    const activatePreview = (url: string) => {
        setUploadedvideoSrc(url);
        setIsPreview(true);
    }

    useEffect(() => {
        const ua = navigator.userAgent;
        let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        setIsSafari(isSafari);
    });

    const handleDownloadButton = (e: any) => {
        setIsProgress(true);
        setIsFileUiDisabled(true);
        setLinkDisplay("none");
    }

    return (
        <div css={onePaddingTiltle}>
            <h2 css={onePadding}>疑似ライブ動画アップローダー</h2>
            <UploaderModal title={modalTitle} message={modalMessage} isModalOpen={isModal} clickHandler={uploaderModalCallback}></UploaderModal>
            <LiveSelection isSelectLiveDisabled={isFileUiDisabled} linkVisibility={linkDisplay} clickHandler={(e) => liveSelectionCallback(e)} ></LiveSelection>
            <UploaderForm key={uploaderFormKey} handleDownloadClick={(e) => handleDownloadButton(e)} clickHandler={(e) => uploaderFormCallback(e)} isFileSelectDisabled={isFileUiDisabled} isDisabled={!isFileSelected || !isLiveSelected || isFileUiDisabled} fileNamelabel={originalFileName}></UploaderForm>
            <div css={imgPreviewDiv}>
                {isScreenShot ? (<ScreenShotTaker videoSrc={previewVideoSrc} videoType={videoType} isSafari={isSafari} screenTimePercent={5}></ScreenShotTaker>) : null}
                {isScreenShot ? (<ScreenShotTaker videoSrc={previewVideoSrc} videoType={videoType} isSafari={isSafari} screenTimePercent={30}></ScreenShotTaker>) : null}
                {isScreenShot ? (<ScreenShotTaker videoSrc={previewVideoSrc} videoType={videoType} isSafari={isSafari} screenTimePercent={60}></ScreenShotTaker>) : null}
            </div>
            {isProgress ? (<Progress originalFileName={originalFileName} fileSize={fileSize} fileType={videoType} uploadPath={uploadPath} file={uploadEvent} s3Key={uploadPath} onCompleteHandler={(e) => activatePreview(e)}></Progress>) : null}
            {isPreview ? (<UploaderVideoPreview title={"4.プレビュー"} videoSrc={uploadedvideoSrc} videoType={videoType} ></UploaderVideoPreview>) : null}
        </div>);
};


export default LargeFileUploader;
